import { Flex, Paper, SectionTitle } from '@shared/components';

import { NewQSetReviewTaskDetailsView } from '../new-qset-review-task-details-view';

export default function NewQSetReviewTaskDetailsSection() {
  return (
    <Paper>
      <Flex
        sx={(theme) => ({ gap: theme.spacing(4), p: theme.spacing(6), flexDirection: 'column' })}
      >
        <SectionTitle title='Task Information' />
        <NewQSetReviewTaskDetailsView />
      </Flex>
    </Paper>
  );
}
